'use strict';

// Assigned Dependencies
module.exports = (function() {
	setupCourseAccordionPadding();
	setupCoursesToggle();
	setupCourseDatesSelection();
	global.setupCourseAccordionPadding = function() {
		setupCourseAccordionPadding();
	};

	$(window).resize(function() {
    	setupCourseAccordionPadding();
    });

})();

function setupCourseAccordionPadding() {
	$('.module-courses').find('.course-dates').each(function() {
		var courseId = $(this).attr('data-course-id');
		var navPanel = $('.course-dates[data-course-id="'+courseId+'"]').parents('.accordion-navigation');
		$(navPanel).each(function() {
	   		var panelToggle = $(this).find('>a');
	   		var panel  = $(this);
	   		$(panel).find('.course-dates').addClass('ready');
	   		var courseDatesHeight = $(panel).find('.course-dates').actual( 'outerHeight' );
	       	$(panel).find('.content').css('padding-bottom', courseDatesHeight);
	   });
	});
}

function setupCoursesToggle() {
	if ($('.course-dates').length > 0) {
		$('.course-dates').each(function() {
			var courseId = $(this).attr('data-course-id');
			if (courseId.length > 0) {{
				var element = $(this);
				$(this).find('.filter-category').click(function(e) {
					e.preventDefault();
					var haveClass = $(this).hasClass('selected');
					$(element).find('.filter-category').removeClass('selected');
					$(this).addClass('selected');
					var categoryId = $(this).attr('data-category-id');
					var haveNewClass = $(this).hasClass('selected');
					$('.course-dates-container').hide();
					$('.course-dates-container[data-category-id="'+categoryId+'"]').show();
					if(haveClass != haveNewClass) {
						$('div[data-type="total_tuition-hide"]').toggle();
					}		
					GAPush({'product_price' : $(this).data('tuitionprice')});
				});
			}}
		});
	}
}

function setupCourseDatesSelection() {

	$('.course-date-selection').click(function(e) {
		var lists = $(this).parents('.course-dates').find('.dates-list');
		var label = $(this);
		var radio = $(this).parent().find('input[type="radio"]');
		if ($(radio).is(':checked') && $(label).hasClass('selected')) {
			e.preventDefault();
			$(radio).removeAttr('checked');
			$(lists).find('.course-date-selection').removeClass('selected').removeAttr('disabled');
		}
		else if (!$(label).hasClass('selected')) {
			$(lists).find('.course-date-selection').removeClass('selected').removeAttr('disabled');
			$(label).addClass('selected');
		}
		else if(!$(label).hasClass('in-cart')) {
			$(label).removeClass('selected');
		}
	});
}